import React from 'react'

import { HeadContent } from '@fourthwall/components'

import { useCurrentShop } from '../../../../hooks/useCurrentShop'
import type { FormValues } from './General.types'
import { GeneralView } from './GeneralView'
import { validationSchema } from './consts'
import { useGeneralShopSettings } from './hooks/useGeneralShopSettings'
import { useMailingListReport } from './hooks/useMailingListReport'
import { useShopRendererDataQuery } from './queries/useShopRendererDataQuery'

export const GeneralContainer = () => {
  const { currentShop, isLoading } = useCurrentShop()
  const { mailingListReport } = useMailingListReport()
  const { shopRendererDataQuery } = useShopRendererDataQuery([{ shop_id: currentShop?.id! }], {
    enabled: !!currentShop?.id,
  })
  const { isSubmitting, handleUpdateShop } = useGeneralShopSettings()

  const initialValues: FormValues = {
    name: currentShop?.name || '',
    customerSupportEmail: currentShop?.contactInfo?.customerSupportEmail || '',
    creatorName: currentShop?.creatorName || '',
    description: currentShop?.description || '',
    socialImage: shopRendererDataQuery.data?.ogImageUrl || '',
    socialImageType: 'Keep',
    cookiePolicy: shopRendererDataQuery.data?.cookiePolicy === 'ShowInEu' || false,
    timezone: currentShop?.timezoneId || 'UTC',
  }

  return (
    <>
      <HeadContent title="General &ndash; Settings" />
      <GeneralView
        initialValues={initialValues}
        validationSchema={validationSchema}
        isLoading={!currentShop || !shopRendererDataQuery.data || isLoading}
        isSubmitting={isSubmitting}
        onMarketingReportDownload={mailingListReport.download}
        onSubmit={handleUpdateShop}
      />
    </>
  )
}
